import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import { useEffect, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import PieChart from "@cloudscape-design/chart-components/pie-chart";
import Highcharts from "highcharts";

import { Box, Button, SpaceBetween } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCommentQuestionOutline, mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemPoll, ItemPollQuestion } from '../../../../../resources/types';
import { buildBreadcrumbItems, exportToExcel, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';

export const MembersEtcPollsResultsPage = () => {
    const { idUser, data, menu, parameters, version, loading, notifications, displayName, RUT } = useGlobalState();


    const [poll, setPoll] = useState<ItemPoll | null>(null);

    const [idPoll, setIdPoll] = useState<number>(0);
    useEffect(() => {
        const handleHashChange = () => {
            const hash = window.location.hash;
            const params = new URLSearchParams(hash.split("?")[1]);
            const id = params.get("id");

            if (id) handleGetPoll(id ? parseInt(id) : 0);
        };

        window.addEventListener("hashchange", handleHashChange);
        // also trigger once on mount
        handleHashChange();

        return () => window.removeEventListener("hashchange", handleHashChange);
    }, []);

    useEffect(() => {

    }, []);

    const handleGetPoll = async (idPoll: number) => {
        try {
            setLoading(true);
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/user/polls/get',
                    'JWT': getCookie("JWT"),

                },
                body: JSON.stringify({
                    idPoll: idPoll,
                })
            });
            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }

            const data = await response.json();
            if (data && data.poll) {
                const updatedPoll = {
                    ...data.poll,
                    questions: data.poll.questions.map((q: ItemPollQuestion) => {
                        const totalVotes = (q.results || []).reduce((sum: number, item: any) => sum + (item.votes || 0), 0);

                        return {
                            ...q,
                            votes: totalVotes,
                            // 2. Map results array to inject individual option percentages
                            results: (q.results || []).map((res: any) => ({
                                ...res,
                                // Trap division by zero: if totalVotes is 0, percentage defaults to 0
                                percentage: totalVotes > 0 ? (res.votes / totalVotes) * 100 : 0
                            }))
                        };
                    })
                };

                setPoll(updatedPoll);
                console.log(updatedPoll)

            }
            //storeAdmin(data);
            // Create a new list with updated 'accesos' field before setting it to state

        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content=
            {poll && (
                <SpaceBetween size="s">
                    <Header variant="h1" actions={
                        <SpaceBetween size="s" direction='horizontal'>

                            <Favorites />

                        </SpaceBetween>
                    }>{poll.poll}</Header>

                    <SpaceBetween size="s" direction='vertical'>
                        {poll.questions.filter((q: any) => q.questionType === "OPTION").map((question, index) => (
                            <SpaceBetween size="s" direction='vertical'>
                                <Box key={index} padding="l">
                                    <Header variant="h2"><Icon path={mdiCommentQuestionOutline} size={1} /> {question.question}</Header>
                                    <SpaceBetween size="m" direction='horizontal'>
                                        {question.results.map((results, idx) => (
                                            <Box key={idx} padding="m">
                                                <Header variant="h3"
                                                    description={`Votos: ${results.votes ?? 0} (${results.percentage?.toFixed(2) ?? 0}%)`}
                                                >{results.answer} </Header>
                                            </Box>

                                        ))}
                                    </SpaceBetween>
                                </Box>

                                <PieChart
                                    highcharts={Highcharts}
                                    series={{
                                        type: "donut",
                                        name: question.question || "Votos", // Name of the series
                                        data: (question.results || []).map((res: any) => ({
                                            name: res.answer || "En blanco", // Candidate / Option name
                                            y: res.votes || 0                // Number of votes received
                                        }))
                                    }}
                                    filter={{ seriesFilter: false }}
                                    tooltip={{
                                        details({ segmentValue, totalValue }) {
                                            return [
                                                {
                                                    key: "Votos obtenidos",
                                                    value: `${segmentValue} ${segmentValue === 1 ? "voto" : "votos"}`
                                                },
                                                {
                                                    key: "Porcentaje",
                                                    value: `${totalValue > 0 ? ((segmentValue / totalValue) * 100).toFixed(1) : 0}%`
                                                }
                                            ];
                                        }
                                    }}
                                    ariaLabel="Storage usage chart"
                                    ariaDescription="Pie chart showing storage usage by category."
                                />
                            </SpaceBetween>


                        ))}
                    </SpaceBetween>
                </SpaceBetween>
            )}

        />
    )
};
